import { Wallet } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { money } from "@/lib/api";

export default function BudgetCard({ projectId }) {
  const { data } = useFetch(`/projects/${projectId}/budget-summary`);
  if (!data?.has_estimate) return null;
  const max = Math.max(...data.categories.map((c) => c.total), 1);
  return (
    <section className="rounded-2xl border bg-card p-6" data-testid="client-budget">
      <div className="flex items-baseline justify-between gap-4">
        <p className="eyebrow flex items-center gap-2"><Wallet className="h-4 w-4" />Budget at a glance</p>
        <p className="stat text-3xl" data-testid="client-budget-total">{money(data.total)}</p>
      </div>
      <ul className="mt-5 space-y-2.5">
        {data.categories.map((c) => (
          <li key={c.name} className="text-sm" data-testid={`client-budget-cat-${c.name.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="flex justify-between"><span>{c.name}</span><span className="font-mono text-xs text-muted-foreground">{money(c.total)}</span></div>
            <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-secondary"><div className="h-full rounded-full bg-primary" style={{ width: `${(c.total / max) * 100}%` }} /></div>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-xs text-muted-foreground">Subtotal {money(data.subtotal)} · HST {data.tax_rate}% {money(data.tax)}. A working estimate for reference; your formal quote and invoices come separately.</p>
    </section>
  );
}
